import React from "react";
import image1 from "../../../Assets/Compliance Certifictes/image.png";
import image2 from "../../../Assets/Compliance Certifictes/image2.png";

const RohsInfoContainer = () => {
  return (
    <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
      {/* left side */}
      <div className="w-full">
        {/* heading */}
        <div className="py-4 md:py-10">
          <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
            <h1 className="">
              <span className="border-b-4 border-[#249742]">Ro</span>HS
            </h1>
          </div>
        </div>

        {/* content */}
        <div>
          <p className="font-normal text-lg text-[#4D4D4D]">
            RoHS stands for Restriction of Hazardous Substances. RoHS, also
            known as Directive 2002/95/EC, originated in the European Union and
            restricts the use of specific hazardous materials found in
            electrical and electronic products. All applicable products in the
            EU market after July 1, 2006 must pass RoHS compliance.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            The restricted materials are hazardous to the environment and
            pollute landfills, and are dangerous in terms of occupational
            exposure during manufacturing and recycling.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            The substances banned under RoHS are lead (Pb), mercury (Hg),
            cadmium (Cd), hexavalent chromium (CrVI), polybrominated biphenyls
            (PBB), polybrominated diphenyl ethers (PBDE), and four different
            phthalates (DEHP, BBP, BBP, DIBP).
          </p>
        </div>
      </div>

      {/* right side */}
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
        <div className="py-0 sm:py-8">
          <img
            src={image2}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>

        <div className="py-0 sm:py-8">
          <img
            src={image1}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default RohsInfoContainer;
